export default __webpack_public_path__ + "static/media/logo.02ed0a89.png";